import React from 'react';
import styled from 'styled-components';
import ScrollToTop from '../components/ScrollToTop';

const FeaturesContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;
`;

const FeatureCard = styled.a`
  background: ${({ theme }) => theme.surface};
  border-radius: 8px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadow};
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: inherit;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
  }
`;

const ProductImage = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover;
`;

const CardContent = styled.div`
  padding: 1.5rem;
`;

const FeatureTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.text};
`;

const FeatureDescription = styled.p`
  color: ${({ theme }) => theme.textSecondary};
  line-height: 1.6;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  margin: 4rem 0 2rem;
  color: ${({ theme }) => theme.text};
  text-align: center;
`;

const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 4rem;
`;

const CategoryItem = styled.div`
  background: ${({ theme }) => theme.surfaceAlt};
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    filter: brightness(0.96);
  }
`;

const CategoryName = styled.h4`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.text};
  margin-bottom: 0.5rem;
`;

const CategoryCount = styled.p`
  color: ${({ theme }) => theme.textSecondary};
  font-size: 0.9rem;
`;

const Features: React.FC = () => {
  const products = [
    {
      id: 1,
      title: '机械键盘',
      description: '高品质机械键盘，青轴设计，RGB背光，人体工学设计，让您的打字体验更上一层楼。',
      image: 'https://picsum.photos/seed/keyboard/800/600',
      link: '#'
    },
    {
      id: 2,
      title: '无线鼠标',
      description: '高精度无线鼠标，人体工学设计，超长续航，适合办公和游戏使用。',
      image: 'https://picsum.photos/seed/mouse/800/600',
      link: '#'
    },
    {
      id: 3,
      title: '显示器支架',
      description: '可调节显示器支架，支持多角度调节，节省桌面空间，保护颈椎健康。',
      image: 'https://picsum.photos/seed/monitor/800/600',
      link: '#'
    },
    {
      id: 4,
      title: '降噪耳机',
      description: '主动降噪耳机，高清音质，舒适佩戴，让您沉浸在音乐的世界中。',
      image: 'https://picsum.photos/seed/headphone/800/600',
      link: '#'
    },
    {
      id: 5,
      title: '机械键盘手托',
      description: '记忆棉材质，舒适支撑，缓解手腕疲劳，提升打字体验。',
      image: 'https://picsum.photos/seed/wristrest/800/600',
      link: '#'
    },
    {
      id: 6,
      title: '显示器挂灯',
      description: '护眼显示器挂灯，无频闪，智能调光，保护您的眼睛健康。',
      image: 'https://picsum.photos/seed/light/800/600',
      link: '#'
    }
  ];

  const categories = [
    {
      name: '外设',
      count: 12
    },
    {
      name: '数码',
      count: 8
    },
    {
      name: '办公',
      count: 6
    },
    {
      name: '生活',
      count: 10
    }
  ];

  return (
    <FeaturesContainer>
      <FeaturesGrid>
        {products.map(product => (
          <FeatureCard key={product.id} href={product.link}>
            <ProductImage src={product.image} alt={product.title} />
            <CardContent>
              <FeatureTitle>{product.title}</FeatureTitle>
              <FeatureDescription>{product.description}</FeatureDescription>
            </CardContent>
          </FeatureCard>
        ))}
      </FeaturesGrid>

      <SectionTitle>商品分类</SectionTitle>
      <CategoryGrid>
        {categories.map((category, index) => (
          <CategoryItem key={index}>
            <CategoryName>{category.name}</CategoryName>
            <CategoryCount>{category.count} 件商品</CategoryCount>
          </CategoryItem>
        ))}
      </CategoryGrid>
      <ScrollToTop />
    </FeaturesContainer>
  );
};

export default Features; 